import { Component, OnInit } from '@angular/core';
import Utils from '@app/utils/utils';
import { Router } from '@angular/router';
import { VERSION } from '@env/version';
import { environment } from '@env/environment';
import { ApiService } from '@app/api/api.service';
import { AgTimeAgoPipe } from '@app/shared/pipes/ag-time-ago/ag-time-ago.pipe';
import { NgbActiveModal } from '@agilent/ui-element';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    providers: [AgTimeAgoPipe]
})
export class AboutComponent implements OnInit {

    version: string = null;
    releaseDate: string = null;
    releaseNotesUrl = '';
    eulaUrl = '';
    privacyPolicyUrl = '';

    constructor(
        private router: Router,
        private apiService: ApiService,
        private activeModal: NgbActiveModal,
        private agTimeAgoPipe: AgTimeAgoPipe
    ) {
    }

    async ngOnInit() {
        try {
            this.version = VERSION;
            this.releaseDate = this.agTimeAgoPipe.transform(environment['release_date']);
            const resp = await this.apiService.getIndex();
            this.releaseNotesUrl = resp.release_notes;
            this.eulaUrl = resp.eula;
            this.privacyPolicyUrl = resp.privacy_policy;
        }
        catch (e) {
            console.error('Error retrieving hub info');
        }
    }

    getAboutIcon() {
        return Utils.getIconFileUrl('cid_hub');
    }

    getFooterImage() {
        const footerImage = '/assets/images/footer.svg';
        const commitHash = VERSION.split(' ')[1] || '';
        return`${footerImage}?${commitHash}`;
    }

    onClose() {
        this.activeModal.close();
    }
}
